import api from '@/api';
import { CompanyTefConfigurationResponse } from './companyTefConfiguration.types';

const path = '/enterprise/v1/company-tef-configurations';

export default {
  async isActive(companyId?: number) {
    const result = api.get(`${path}/${companyId}`, null) as unknown;

    return result as CompanyTefConfigurationResponse;
  },
};
